import { UseCase } from 'modules/data/domain';

import { messages } from './GettingStarted.messages';
import { GuideStep } from './GettingStarted.types';

export const mapTextByUseCases = {
    [UseCase.StreamlineAuditProcesses]: messages.auditProcesses,
    [UseCase.EstablishInternalFinancialControls]: messages.financialControls,
    [UseCase.AutomateApprovalWorkflows]: messages.approvalAutomation,
    [UseCase.SpeedupTheApprovalProcess]: messages.approvalSpeedup,

    [[UseCase.StreamlineAuditProcesses, UseCase.EstablishInternalFinancialControls].join(',')]:
        messages.auditAndControls,
    [[UseCase.StreamlineAuditProcesses, UseCase.AutomateApprovalWorkflows].join(',')]: messages.auditAndAutomation,
    [[UseCase.StreamlineAuditProcesses, UseCase.SpeedupTheApprovalProcess].join(',')]: messages.auditAndSpeedup,
    [[UseCase.EstablishInternalFinancialControls, UseCase.AutomateApprovalWorkflows].join(',')]:
        messages.controlsAndAutomation,
    [[UseCase.EstablishInternalFinancialControls, UseCase.SpeedupTheApprovalProcess].join(',')]:
        messages.controlsAndSpeedup,
    [[UseCase.AutomateApprovalWorkflows, UseCase.SpeedupTheApprovalProcess].join(',')]: messages.automationAndSpeedup,

    [[
        UseCase.StreamlineAuditProcesses,
        UseCase.EstablishInternalFinancialControls,
        UseCase.AutomateApprovalWorkflows,
    ].join(',')]: messages.auditControlsAutomation,
    [[
        UseCase.StreamlineAuditProcesses,
        UseCase.EstablishInternalFinancialControls,
        UseCase.SpeedupTheApprovalProcess,
    ].join(',')]: messages.auditControlsSpeedup,

    [[UseCase.StreamlineAuditProcesses, UseCase.AutomateApprovalWorkflows, UseCase.SpeedupTheApprovalProcess].join(
        ','
    )]: messages.auditAutomationSpeedup,

    [[
        UseCase.EstablishInternalFinancialControls,
        UseCase.AutomateApprovalWorkflows,
        UseCase.SpeedupTheApprovalProcess,
    ].join(',')]: messages.controlsAutomationSpeedup,

    [[
        UseCase.StreamlineAuditProcesses,
        UseCase.EstablishInternalFinancialControls,
        UseCase.AutomateApprovalWorkflows,
        UseCase.SpeedupTheApprovalProcess,
    ].join(',')]: messages.default,
};

export const videoLinksQBooks = {
    step3: 'https://approvalmax.com/hubfs/Video%20guides/Final_GuideVideo2_QBO_1.mp4',
    step4: 'https://approvalmax.com/hubfs/Video%20guides/Final_GuideVideo3_QBO_2.mp4',
    step7: 'https://approvalmax.com/hubfs/Video%20guides/Final_GuideVideo4_QBO_2.mp4',
};

export const videoLinksXero = {
    step3: 'https://approvalmax.com/hubfs/Video%20guides/Final_GuideVideo2_4.mp4',
    step4: 'https://approvalmax.com/hubfs/Video%20guides/Final_GuideVideo3_4.mp4',
    step7: 'https://approvalmax.com/hubfs/Video%20guides/Final_GuideVideo4_4.mp4',
};

export const videoLinksStandalone = {
    ...videoLinksXero,
    step3: 'https://approvalmax.com/hubfs/Video%20guides/GuideVideo5.mp4',
};

export const videoLinksStandalonePreferredQbooks = {
    ...videoLinksQBooks,
    step3: 'https://approvalmax.com/hubfs/Video%20guides/GuideVideo5.mp4',
};

export const stepsOrdered = [
    GuideStep.TeamInvitation,
    GuideStep.WorkflowSetup,
    GuideStep.WorkflowSetupStandalone,
    GuideStep.RequestCreation,
    GuideStep.RequestApproval,
    GuideStep.ConnectAccountingSystem,
    GuideStep.MobileAppDownload,
    GuideStep.SubscriptionPlan,
];
